import React from 'react';
import convert from "convert";
import type {Unit} from "convert";

// Types ----

declare module "convert" {
  function convert<Q extends number | bigint>(quantity: Q, from: Unit): Converter<Q, Unit>;
}

type ConvertedValueProps = {
  value: number
  fromUnit: Unit
  toUnit: Unit
};

// Component ----

function ConvertedValue({fromUnit, toUnit, value}: ConvertedValueProps) {

  const convertedValue = convert(value, fromUnit)
    .to(toUnit)
    .toFixed(0)
    .toLocaleString();

  return (
    <span>
      {convertedValue} {toUnit}
    </span>
  );
}

// Export ----

export default ConvertedValue;